import IconButton from "@mui/material/IconButton";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import { DeleteRounded, EditRounded, ExpandMore } from "@mui/icons-material";

const SingleFaq = ({ index, item, onEditFaq, onDeleteFaq }) => {
  //FUNCTIONS
  const handleEditing = (e, item) => {
    e.stopPropagation();
    onEditFaq(item);
  };

  const handleDeleting = (e, item) => {
    e.stopPropagation();
    onDeleteFaq(item);
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="accordion-faq"
        id="accordion-faq"
      >
        {item.id}. {item?.question}
      </AccordionSummary>
      <AccordionDetails>{item?.answer}</AccordionDetails>
      <AccordionActions>
        <IconButton onClick={(e) => handleEditing(e, item)}>
          <EditRounded />
        </IconButton>
        <IconButton onClick={(e) => handleDeleting(e, item)}>
          <DeleteRounded />
        </IconButton>
      </AccordionActions>
    </Accordion>
  );
};

export default SingleFaq;
